<template>
    <div>
        <div class="d-flex flex-wrap justify-content-between">
            <div class="d-flex flex-wrap">
                <b-button :disabled="levelOneAdsWithLevelTwoAds.length == 0" class="mb-2 mr-2 btn-responsive" size="sm" variant="primary" @click="toggleSelectAll">
                    {{ selectAll ? "Deselect all rows" : "Select all rows" }}
                </b-button>
                <b-button disabled class="mb-2 mr-2 btn-responsive" size="sm" variant="danger" @click="excludeSelectedRows">
                    Exclude rows
                </b-button>
                <label class="totalRowsStyle mb-2 mr-5"> Response rows: {{ getRowCount }} </label>
            </div>
            <span style="font-size: 0.8rem;" class="text-right align-self-end mb-2"
                >* tv- and online-data are components for calculation of the total, not exactly the same as the values for tv and online video.</span
            >
        </div>
        <b-table
            no-sort-reset
            thead-class="stickyfancytableheader"
            class="tablemainresultclass"
            :items="levelOneAdsWithLevelTwoAds"
            :fields="columns"
            select-mode="multi"
            primary-key="index"
            :sort-compare-options="{ numeric: true, sensitivity: 'base' }"
            sort-compare-locale="sv"
            :head-variant="'dark'"
            @sort-changed="sortingChanged"
            bordered
            small
            striped
            :per-page="visibleRows"
            :current-page="currentPage"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :no-local-sorting="true"
        >
            <template v-slot:top-row v-if="$store.getters.getAdsSumVisible">
                <td :colspan="getFirstSummaryColspan">
                    <div class="sumrowtop">
                        <div v-for="(sum, iSum) in result.data.summary" class="sumrowdiv" v-bind:key="iSum">
                            <span>{{ sum.name }}:</span>
                        </div>
                    </div>
                </td>
                <td v-for="(measure, iMeasure) in columns.filter(c => c.isMeasure)" class="text-right" v-bind:key="iMeasure" colspan="1">
                    <div v-for="(sum, iSum) in result.data.summary" class="sumrowdiv" v-bind:key="iSum">
                        {{ sum.measures[measure.key] }}
                    </div>
                </td>
            </template>
            <template v-slot:cell(plussign)="row">
                <div v-if="row.item.levelTwoAds.length > 1">
                    <div @click="clickedPlusMinusSign($event, row)" class="plusminusbutton">
                        <font-awesome-icon v-if="!row.item._showDetails" icon="fa fa-plus-circle" class="plusminusicon" />
                        <font-awesome-icon v-else icon="fa fa-minus-circle fa-1x" class="plusminusicon" />
                        <div class="plusminusline"></div>
                    </div>
                </div>
                <div v-else-if="row.item.levelTwoAds.length === 1">
                    {{ setLevelOneAdToLevelTwoAd(row.item) }}
                </div>
            </template>
            <template v-slot:cell(chosen)="row">
                <b-form-checkbox
                    class="choose-checkbox-div"
                    v-model="row.item.chosen"
                    @change="onLvlOneCheckClick(row.item), checkSelection(), shiftClick(row)"
                    :indeterminate.sync="row.item.indeterminate"
                ></b-form-checkbox>
            </template>
            <template v-slot:head()="field">
                <span class="measureheader" v-html="getTableFieldLabel(field)"></span>
            </template>
            <template v-slot:cell(providerName)="row">
                <span v-if="row.item.providerNameVhtml != undefined" v-html="row.item.providerNameVhtml"></span>
                <span v-else>{{ row.item.providerName }}</span>
            </template>
            <template #row-details="row">
                <b-table-lite
                    class="mb-0 detail-row-table"
                    :class="groupClassOddEven(row.index)"
                    :tbody-tr-class="detailRowClassOddEven(row.index)"
                    borderless
                    thead-class="hideheader"
                    :fields="columns"
                    :items="row.item.levelTwoAds"
                    :striped="false"
                >
                    <template v-slot:cell(chosen)="detailRow">
                        <b-form-checkbox class="choose-checkbox-div" v-model="detailRow.item.chosen" @change="checkSelection()" disabled></b-form-checkbox>
                    </template>
                    <template v-slot:cell(providerName)="detailRow">
                        <span v-if="detailRow.item.providerNameVhtml != undefined" v-html="detailRow.item.providerNameVhtml"></span>
                        <span v-else>{{ detailRow.item.providerName }}</span>
                    </template>
                </b-table-lite>
            </template>
        </b-table>
        <b-pagination @change="pageChange" class="justify-content-center" v-model="currentPage" :total-rows="levelOneAdsWithLevelTwoAds.length" :per-page="visibleRows"></b-pagination>
    </div>
</template>
<script>
import * as Mutations from "@/store/modules/ads/mutation-types"
import { sortResultTable } from "../../../api/utils.js"

export default {
    name: "ResultTableMainAd",
    data() {
        return {
            selectAll: false,
            visibleRows: 50,
            currentPage: 1,
            shiftHeld: false,
            currentlySelectedRowIdx: null,
            previouslySelectedRowIdx: null,
        }
    },
    props: {},
    mounted() {
        const _self = this
        document.addEventListener("mousedown", function(e) {
            _self.shiftHeld = e.shiftKey
            if (e.shiftKey == true) {
                e.preventDefault()
            }
        })
        sortResultTable({ sortBy: this.sortBy, sortDesc: this.sortDesc, isNumber: true }, this.levelOneAdsWithLevelTwoAds)
    },
    computed: {
        result() {
            return this.$store.getters.getAdsResults
        },
        getFirstSummaryColspan() {
            return this.columns.filter(c => !c.isMeasure).length
        },
        getRowCount() {
            let totalLength = this.levelOneAdsWithLevelTwoAds.length
            let previousRowsAndCurrentRows = this.visibleRows * this.currentPage
            if (previousRowsAndCurrentRows > totalLength) {
                return `${totalLength}/${totalLength}`
            }
            return `${previousRowsAndCurrentRows}/${totalLength}`
        },
        levelOneAdsWithLevelTwoAds() {
            return this.$store.getters.getAdsResults.data.levelOneAdsWithLevelTwoAds
        },
        columns() {
            let columns = [...this.$store.getters.getAdsResults.data.columns]
            columns.unshift(
                { key: "plussign", tdClass: "plusminussigntd", thClass: "plusminussignth", label: "", isMeasure: false },
                { key: "chosen", thClass: "choose-checkbox-th", label: "Selected", isMeasure: false }
            )
            return columns
        },
        sortBy: {
            get() {
                return this.$store.getters.getAdsResults.sortBy
            },
            set(sortByNewValue) {
                this.$store.commit(Mutations.setAdsResults, {
                    ...this.$store.getters.getAdsResults,
                    sortBy: sortByNewValue,
                })
            },
        },
        sortDesc: {
            get() {
                return this.$store.getters.getAdsResults.sortDesc
            },
            set(sortDescNewValue) {
                this.$store.commit(Mutations.setAdsResults, {
                    ...this.$store.getters.getAdsResults,
                    sortDesc: sortDescNewValue,
                })
            },
        },
    },

    methods: {
        pageChange() {
            this.currentlySelectedRowIdx = null
            this.previouslySelectedRowIdx = null
        },
        sortingChanged(sortInfo) {
            this.$store.commit("setAdsHaveSelectedRow", false)
            this.selectAll = false
            this.currentlySelectedRowIdx = null
            this.previouslySelectedRowIdx = null
            for (let levelOneAd of this.levelOneAdsWithLevelTwoAds) {
                levelOneAd.chosen = false
                this.onLvlOneCheckClick(levelOneAd)
            }
            if (sortInfo.sortBy.includes("measure")) sortInfo.isNumber = true
            else sortInfo.isNumber = this.$store.getters.getAdsColumnTypes.find(ad => ad.value === sortInfo.sortBy).isNumber
            sortResultTable(sortInfo, this.levelOneAdsWithLevelTwoAds)
        },
        groupClassOddEven(index) {
            return index % 2 == 0 ? "group-even" : "group-odd"
        },
        detailRowClassOddEven(index) {
            return index % 2 == 0 ? "row-even detail-row" : "row-odd detail-row"
        },
        setLevelOneAdToLevelTwoAd(row) {
            for (const column of this.$store.getters.getAdsResults.data.columns) {
                if (column.key === "providerName" && row.levelTwoAds[0].providerNameVhtml != undefined) {
                    row.providerNameVhtml = row.levelTwoAds[0].providerNameVhtml
                } else {
                    row[column.key] = row.levelTwoAds[0][column.key]
                }
            }
        },
        clickedPlusMinusSign(event, row) {
            event.stopPropagation()
            this.$set(row.item, "_showDetails", !row.item._showDetails)
        },
        onLvlOneCheckClick(row) {
            for (const l2 of row.levelTwoAds) {
                l2.chosen = row.chosen
            }
        },
        checkSelection() {
            let selectCount = 0
            let rowCount = 0
            for (const l1 of this.levelOneAdsWithLevelTwoAds) {
                for (const l2 of l1.levelTwoAds) {
                    if (l2.chosen == true) {
                        selectCount++
                    }
                    rowCount++
                }
            }
            this.selectAll = selectCount >= rowCount
            const hasSelection = selectCount > 0
            this.$store.commit(Mutations.setAdsHaveSelectedRow, hasSelection)
        },
        shiftClick(row) {
            if (row.item.chosen) {
                if (this.currentlySelectedRowIdx !== null) {
                    this.previouslySelectedRowIdx = this.currentlySelectedRowIdx
                }
                let previousRows = 0
                if (this.currentPage > 1) previousRows = this.visibleRows * (this.currentPage - 1)
                this.currentlySelectedRowIdx = previousRows + row.index
                if (this.currentlySelectedRowIdx === null || this.previouslySelectedRowIdx === null) return
                if (this.shiftHeld && this.currentlySelectedRowIdx != this.previouslySelectedRowIdx) {
                    let sliceFrom = 0
                    let sliceTo = 0
                    if (this.currentlySelectedRowIdx < this.previouslySelectedRowIdx) {
                        sliceFrom = this.currentlySelectedRowIdx
                        sliceTo = this.previouslySelectedRowIdx
                    } else {
                        sliceFrom = this.previouslySelectedRowIdx
                        sliceTo = this.currentlySelectedRowIdx
                    }
                    var shiftClickedLvlOneAds = this.levelOneAdsWithLevelTwoAds.slice(sliceFrom, sliceTo + 1)
                    for (let levelOneAd of shiftClickedLvlOneAds) {
                        levelOneAd.chosen = true
                        this.onLvlOneCheckClick(levelOneAd)
                    }
                }
            } else {
                this.currentlySelectedRowIdx = null
                this.previouslySelectedRowIdx = null
            }
        },
        getTableFieldLabel(field) {
            if (!field.field.key.includes("measure")) {
                return field.field.label
            }

            if (field.field.subHeader.includes("(tv-data)")) {
                field.field.targetGroupHeader = field.field.subHeader.replace("(tv-data)", "")
                field.field.sourceHeader = "(tv-data)*"
            } else if (field.field.subHeader.includes("(online-data)")) {
                field.field.targetGroupHeader = field.field.subHeader.replace("(online-data)", "")
                field.field.sourceHeader = "(online-data)*"
            } else if (field.field.subHeader.includes("Total")) {
                field.field.targetGroupHeader = field.field.subHeader.replace("Total", "")
                field.field.sourceHeader = "Total"
            }

            return `${field.field.header} <span class="measureagewrapper">${field.field.targetGroupHeader}</span><span class="measureagewrapper">${field.field.sourceHeader}</span>`
        },
        toggleSelectAll() {
            this.selectAll = !this.selectAll
            for (const l1 of this.levelOneAdsWithLevelTwoAds) {
                l1.indeterminate = false
            }
            //checkbox indeterminate status is lagging, wait to set chosen status
            this.$nextTick(() => {
                for (const l1 of this.levelOneAdsWithLevelTwoAds) {
                    l1.chosen = this.selectAll
                    for (const l2 of l1.levelTwoAds) {
                        l2.chosen = this.selectAll
                    }
                }
            })
            this.$store.commit(Mutations.setAdsHaveSelectedRow, this.selectAll)
        },
        excludeSelectedRows() {
            this.selectAll = false
            this.$store.commit(Mutations.setAdsSumVisible, false)
            this.$store.commit(Mutations.setAdsHasExcludedRow, true)
            this.$store.commit("setAdsHaveSelectedRow", false)
            const updatedResults = {
                ...this.$store.getters.getAdsResults,
                data: {
                    ...this.$store.getters.getAdsResults.data,
                    levelOneAdsWithLevelTwoAds: this.levelOneAdsWithLevelTwoAds.filter(levelOneAd => !levelOneAd.chosen),
                },
            }
            this.$store.commit(Mutations.setAdsResults, updatedResults)
            this.currentlySelectedRowIdx = null
            this.previouslySelectedRowIdx = null
        },
    },
}
</script>
<style scoped>
.plusminusicon {
    color: #337ab7;
    font-size: 1.25em;
    margin: auto;
    display: block;
}
table.tablemainresultclass {
    min-width: 1200px;
}
::v-deep .tablemainresultclass th {
    font-size: 0.8rem;
    background-color: #337ab7 !important;
    border-color: #bfd5e8 !important;
    border-top: white;
    border-width: 2px 1px 2px 1px !important;
    vertical-align: middle;
    padding-top: 0;
    padding-bottom: 0;
}
::v-deep .detail-row {
    background-color: transparent !important;
}
::v-deep .detail-row td {
    font-size: 0.65rem;
}
/* table is using bootstrap striped attribute for main rows and index based css for detail rows*/
::v-deep .row-even {
    background-color: #ffffff;
}
::v-deep .row-odd {
    background-color: #f2f2f2;
}
::v-deep .group-even {
    background-color: #f2f2f2;
}
::v-deep .group-odd {
    background-color: #ffffff;
}
::v-deep tbody tr td {
    border-bottom: none;
    border-top: 1px solid #dee2e6;
    border-left: 1px solid #dee2e6;
    border-right: 1px solid #dee2e6;
}

::v-deep .titleheadercolumn {
    width: 20%;
}
::v-deep .plusminusbutton {
    display: flex;
    position: relative;
    z-index: 2;
    padding: 0.4em 0;
    margin: -0.4em 0;
    cursor: pointer;
}
/* hiding table group borders */
::v-deep .detail-row-table tbody tr td {
    border: none;
}
::v-deep .b-table-has-details td:not(:last-child) {
    border-left: 1px solid rgba(255, 255, 255, 0);
    border-right: 1px solid rgba(255, 255, 255, 0);
}

::v-deep .b-table-has-details td:first-child {
    border-left: 1px solid #dee2e6;
    border-right: 0px solid #dee2e6;
}
::v-deep .b-table-has-details td:nth-child(2) {
    border-left: 0px solid #dee2e6;
    border-right: 0px solid #dee2e6;
}
/* constructing the hierarchy lines in the plussign column */
::v-deep .plusminussigntd {
    padding: 0;
    position: relative;
}
/* hiding the overflowing line behind transparent part of +/- icon */
::v-deep .plusminusbutton::before {
    content: "";
    background: white;
    z-index: -1;
    height: 37%;
    left: 12px;
    position: absolute;
    top: 32%;
    width: 10px;
}
::v-deep .b-table-has-details td:first-child::after {
    content: "";
    background: #a9b1b8;
    height: 42%;
    left: 16px;
    position: absolute;
    top: 60%;
    width: 0.5px;
    z-index: 1;
}
::v-deep .detail-row-table .plusminussigntd::before {
    content: "";
    background: #a9b1b8;
    width: 50%;
    left: 16px;
    position: absolute;
    top: 50%;
    height: 0.5px;
}
::v-deep .detail-row-table .plusminussigntd:first-child::after {
    content: "";
    background: #a9b1b8;
    height: 100%;
    left: 16px;
    position: absolute;
    top: -50%;
    width: 0.5px;
}
</style>
